import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "security-settings"
};
const _hoisted_2 = {
  class: "first-settings"
};
const _hoisted_3 = {
  class: "first-title"
};
const _hoisted_4 = {
  class: "second-title"
};
const _hoisted_5 = {
  style: {
    "display": "flex",
    "gap": "8px",
    "width": "100%"
  }
};
const _hoisted_6 = {
  class: "second-title"
};
const _hoisted_7 = {
  style: {
    "display": "flex",
    "gap": "8px",
    "width": "100%"
  }
};
const _hoisted_8 = {
  class: "second-title token-title"
};
const _hoisted_9 = {
  class: "token-actions"
};
const _hoisted_10 = {
  class: "token-table-container"
};
const _hoisted_11 = {
  class: "table-cell-content"
};
const _hoisted_12 = {
  class: "table-cell-content"
};
const _hoisted_13 = {
  class: "token-display"
};
const _hoisted_14 = {
  class: "table-cell-content"
};
const _hoisted_15 = {
  class: "table-cell-content"
};
const _hoisted_16 = {
  class: "table-cell-content"
};
const _hoisted_17 = {
  class: "table-cell-content"
};
const _hoisted_18 = {
  class: "table-cell-content action-buttons"
};
const _hoisted_19 = {
  class: "first-settings"
};
const _hoisted_20 = {
  class: "first-title"
};
const _hoisted_21 = {
  class: "second-title"
};
const _hoisted_22 = {
  class: "second-title"
};
const _hoisted_23 = {
  class: "query-param-list"
};
const _hoisted_24 = {
  class: "query-param-list"
};
const _hoisted_25 = {
  class: "first-settings"
};
const _hoisted_26 = {
  class: "first-title"
};
const _hoisted_27 = {
  class: "second-title"
};
const _hoisted_28 = {
  class: "second-title"
};
const _hoisted_29 = {
  class: "second-title"
};
const _hoisted_30 = {
  class: "second-title"
};
const _hoisted_31 = {
  class: "form-item-hint"
};
const _hoisted_32 = {
  class: "form-item-hint"
};
const _hoisted_33 = {
  style: {
    "display": "flex",
    "gap": "10px",
    "width": "100%"
  }
};
const _hoisted_34 = {
  class: "dialog-footer"
};
const _hoisted_35 = {
  style: {
    "display": "flex",
    "gap": "10px",
    "width": "100%"
  }
};
const _hoisted_36 = {
  class: "dialog-footer"
};
const _hoisted_37 = {
  class: "token-result"
};
const _hoisted_38 = {
  style: {
    "margin-bottom": "15px",
    "color": "#e6a23c"
  }
};
const _hoisted_39 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_form = _resolveComponent("el-form");
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_FloatingSaveButton = _resolveComponent("FloatingSaveButton");
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _directive_loading = _resolveDirective("loading");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('sysSecurity.authManagement')), 1), _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t('sysSecurity.userAuth')), 1), _createVNode(_component_el_form, {
    model: $data.authSettings.user,
    rules: $options.userPassRules,
    ref: "userPassForm",
    "label-width": "120px"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: _ctx.$t('sysSecurity.uploadPassword'),
      prop: "authCode"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_input, {
        modelValue: $data.authSettings.user.authCode,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.authSettings.user.authCode = $event),
        type: "password",
        "show-password": "",
        onInput: $options.handleUserPassInput,
        autocomplete: "new-password",
        placeholder: $data.authSettings.user._hasPassword ? _ctx.$t('sysSecurity.passwordUnchanged') : '',
        disabled: $data.clearUserPassword
      }, null, 8, ["modelValue", "onInput", "placeholder", "disabled"]), $data.authSettings.user._hasPassword ? (_openBlock(), _createBlock(_component_el_checkbox, {
        key: 0,
        modelValue: $data.clearUserPassword,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.clearUserPassword = $event),
        onChange: $options.handleClearUserPassword
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.clearPassword')), 1)]),
        _: 1
      }, 8, ["modelValue", "onChange"])) : _createCommentVNode("", true)])]),
      _: 1
    }, 8, ["label"]), _createVNode(_Transition, {
      name: "fade-slide",
      mode: "out-in"
    }, {
      default: _withCtx(() => [$data.showUserPassConfirm ? (_openBlock(), _createBlock(_component_el_form_item, {
        label: _ctx.$t('sysSecurity.confirmPassword'),
        prop: "confirmNewUserPassword",
        key: "user-confirm"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.authSettings.user.confirmNewUserPassword,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.authSettings.user.confirmNewUserPassword = $event),
          type: "password",
          "show-password": "",
          autocomplete: "new-password"
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"])) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }, 8, ["model", "rules"]), _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t('sysSecurity.adminAuth')), 1), _createVNode(_component_el_form, {
    model: $data.authSettings.admin,
    rules: $options.adminPassRules,
    ref: "adminPassForm",
    "label-width": "120px"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: _ctx.$t('sysSecurity.adminUsername'),
      prop: "adminUsername"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.authSettings.admin.adminUsername,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.authSettings.admin.adminUsername = $event),
        autocomplete: "new-password",
        disabled: $data.clearAdminPassword
      }, null, 8, ["modelValue", "disabled"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: _ctx.$t('sysSecurity.adminPassword'),
      prop: "adminPassword"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_input, {
        modelValue: $data.authSettings.admin.adminPassword,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.authSettings.admin.adminPassword = $event),
        type: "password",
        "show-password": "",
        onInput: $options.handleAdminPassInput,
        autocomplete: "new-password",
        placeholder: $data.authSettings.admin._hasPassword ? _ctx.$t('sysSecurity.passwordUnchanged') : '',
        disabled: $data.clearAdminPassword
      }, null, 8, ["modelValue", "onInput", "placeholder", "disabled"]), $data.authSettings.admin._hasPassword ? (_openBlock(), _createBlock(_component_el_checkbox, {
        key: 0,
        modelValue: $data.clearAdminPassword,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.clearAdminPassword = $event),
        onChange: $options.handleClearAdminPassword
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.clearPassword')), 1)]),
        _: 1
      }, 8, ["modelValue", "onChange"])) : _createCommentVNode("", true)])]),
      _: 1
    }, 8, ["label"]), _createVNode(_Transition, {
      name: "fade-slide",
      mode: "out-in"
    }, {
      default: _withCtx(() => [$data.showAdminPassConfirm ? (_openBlock(), _createBlock(_component_el_form_item, {
        label: _ctx.$t('sysSecurity.confirmPassword'),
        prop: "confirmNewAdminPassword",
        key: "admin-confirm"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.authSettings.admin.confirmNewAdminPassword,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.authSettings.admin.confirmNewAdminPassword = $event),
          type: "password",
          "show-password": "",
          autocomplete: "new-password"
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"])) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }, 8, ["model", "rules"]), _createElementVNode("h4", _hoisted_8, [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.apiTokenManagement')) + " ", 1), _createElementVNode("a", _hoisted_9, [_createVNode(_component_el_button, {
    type: "primary",
    size: "small",
    onClick: _cache[7] || (_cache[7] = $event => $data.showCreateTokenDialog = true),
    circle: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
      icon: "plus"
    })]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_10, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
    data: $data.apiTokens,
    class: "token-table"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "name",
      label: _ctx.$t('sysSecurity.tokenName'),
      "header-align": "center"
    }, {
      default: _withCtx(scope => [_createElementVNode("div", _hoisted_11, _toDisplayString(scope.row.name), 1)]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_table_column, {
      prop: "token",
      label: _ctx.$t('sysSecurity.tokenValue'),
      "header-align": "center"
    }, {
      default: _withCtx(scope => [_createElementVNode("div", _hoisted_12, [_createElementVNode("span", _hoisted_13, _toDisplayString(scope.row.token), 1)])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_table_column, {
      prop: "permissions",
      label: _ctx.$t('sysSecurity.permissions'),
      "header-align": "center"
    }, {
      default: _withCtx(scope => [_createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.permissions, perm => {
        return _openBlock(), _createBlock(_component_el_tag, {
          key: perm,
          size: "small",
          class: "permission-tag"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($options.getPermissionText(perm)), 1)]),
          _: 2
        }, 1024);
      }), 128))])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_table_column, {
      prop: "createdAt",
      label: _ctx.$t('sysSecurity.createdAt'),
      "header-align": "center"
    }, {
      default: _withCtx(scope => [_createElementVNode("div", _hoisted_15, _toDisplayString($options.formatDate(scope.row.createdAt)), 1)]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_table_column, {
      label: _ctx.$t('sysSecurity.status'),
      "header-align": "center",
      width: "90"
    }, {
      default: _withCtx(scope => [_createElementVNode("div", _hoisted_16, [_createVNode(_component_el_tag, {
        type: $options.getTokenStatus(scope.row.expiresAt).status === 'active' ? 'success' : 'danger',
        size: "small"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($options.getTokenStatus(scope.row.expiresAt).label), 1)]),
        _: 2
      }, 1032, ["type"])])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_table_column, {
      label: _ctx.$t('sysSecurity.expiresAt'),
      "header-align": "center"
    }, {
      default: _withCtx(scope => [_createElementVNode("div", _hoisted_17, _toDisplayString($options.getTokenStatus(scope.row.expiresAt).expiresText), 1)]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_table_column, {
      label: _ctx.$t('sysSecurity.operation'),
      fixed: "right",
      "header-align": "center"
    }, {
      default: _withCtx(scope => [_createElementVNode("div", _hoisted_18, [_createVNode(_component_el_button, {
        class: "action-button",
        size: "small",
        onClick: $event => $options.editToken(scope.row)
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.editBtn')), 1)]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        class: "action-button",
        size: "small",
        type: "danger",
        onClick: $event => $options.deleteToken(scope.row.id)
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.deleteBtn')), 1)]),
        _: 1
      }, 8, ["onClick"])])]),
      _: 1
    }, 8, ["label"])]),
    _: 1
  }, 8, ["data"])), [[_directive_loading, $data.tokenLoading]])])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("h3", _hoisted_20, _toDisplayString(_ctx.$t('sysSecurity.uploadManagement')), 1), _createElementVNode("h4", _hoisted_21, [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.imageReview')) + " ", 1), _createVNode(_component_el_tooltip, {
    content: _ctx.$t('sysSecurity.imageReviewTooltip'),
    placement: "top"
  }, {
    default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
      icon: "question-circle",
      style: {
        "margin-left": "5px",
        "cursor": "pointer"
      }
    })]),
    _: 1
  }, 8, ["content"])]), _createVNode(_component_el_form, {
    model: $data.uploadSettings.moderate,
    "label-width": "120px"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: _ctx.$t('sysSecurity.enableReview')
    }, {
      default: _withCtx(() => [_createVNode(_component_el_switch, {
        modelValue: $data.uploadSettings.moderate.enabled,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.uploadSettings.moderate.enabled = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: _ctx.$t('sysSecurity.reviewChannel')
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.uploadSettings.moderate.channel,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.uploadSettings.moderate.channel = $event),
        placeholder: _ctx.$t('sysSecurity.reviewChannelPlaceholder')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "moderatecontent.com",
          value: "moderatecontent.com"
        }), _createVNode(_component_el_option, {
          label: "nsfwjs",
          value: "nsfwjs"
        })]),
        _: 1
      }, 8, ["modelValue", "placeholder"])]),
      _: 1
    }, 8, ["label"]), $data.uploadSettings.moderate.channel === 'moderatecontent.com' ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 0,
      label: _ctx.$t('sysSecurity.apiKey')
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.uploadSettings.moderate.moderateContentApiKey,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.uploadSettings.moderate.moderateContentApiKey = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"])) : _createCommentVNode("", true), $data.uploadSettings.moderate.channel === 'nsfwjs' ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 1,
      label: _ctx.$t('sysSecurity.apiPath')
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.uploadSettings.moderate.nsfwApiPath,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.uploadSettings.moderate.nsfwApiPath = $event),
        placeholder: "https://nsfwjs.your.domain"
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["model"]), _createElementVNode("h4", _hoisted_22, [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.ipQuery')) + " ", 1), _createVNode(_component_el_tooltip, {
    content: _ctx.$t('sysSecurity.ipQueryTooltip'),
    placement: "top"
  }, {
    default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
      icon: "question-circle",
      style: {
        "margin-left": "5px",
        "cursor": "pointer"
      }
    })]),
    _: 1
  }, 8, ["content"])]), _createVNode(_component_el_form, {
    model: $data.uploadSettings.ipQuery,
    "label-width": "120px"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: _ctx.$t('sysSecurity.enableIpQuery')
    }, {
      default: _withCtx(() => [_createVNode(_component_el_switch, {
        modelValue: $data.uploadSettings.ipQuery.enabled,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.uploadSettings.ipQuery.enabled = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: _ctx.$t('sysSecurity.ipQueryChannel')
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.uploadSettings.ipQuery.channel,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.uploadSettings.ipQuery.channel = $event),
        placeholder: _ctx.$t('sysSecurity.ipQueryChannelPlaceholder')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: _ctx.$t('sysSecurity.customApi'),
          value: "customApi"
        }, null, 8, ["label"])]),
        _: 1
      }, 8, ["modelValue", "placeholder"])]),
      _: 1
    }, 8, ["label"]), $data.uploadSettings.ipQuery.channel === 'customApi' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createVNode(_component_el_form_item, {
      label: _ctx.$t('sysSecurity.apiPath')
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.uploadSettings.ipQuery.customApi.url,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.uploadSettings.ipQuery.customApi.url = $event),
        placeholder: "https://api.example.com/ip"
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: _ctx.$t('sysSecurity.queryParams')
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.uploadSettings.ipQuery.customApi.params, (param, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "query-param-row"
        }, [_createVNode(_component_el_input, {
          modelValue: param.key,
          "onUpdate:modelValue": $event => param.key = $event,
          placeholder: _ctx.$t('sysSecurity.paramNamePlaceholder')
        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]), _createVNode(_component_el_input, {
          modelValue: param.value,
          "onUpdate:modelValue": $event => param.value = $event,
          placeholder: _ctx.$t('sysSecurity.paramValuePlaceholder')
        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]), _createVNode(_component_el_button, {
          type: "danger",
          plain: "",
          circle: "",
          onClick: $event => $options.removeIpQueryParam(index),
          disabled: $data.uploadSettings.ipQuery.customApi.params.length <= 1
        }, {
          default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
            icon: "trash-alt"
          })]),
          _: 1
        }, 8, ["onClick", "disabled"])]);
      }), 128)), _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        onClick: $options.addIpQueryParam
      }, {
        default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
          icon: "plus"
        }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('sysSecurity.addQueryParam')), 1)]),
        _: 1
      }, 8, ["onClick"])])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, null, {
      label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.responseFields')) + " ", 1), _createVNode(_component_el_tooltip, {
        content: _ctx.$t('sysSecurity.responseFieldsTip'),
        placement: "top"
      }, {
        default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
          icon: "question-circle",
          style: {
            "margin-left": "5px",
            "cursor": "pointer"
          }
        })]),
        _: 1
      }, 8, ["content"])]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.uploadSettings.ipQuery.customApi.responseFields, (field, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "response-field-row"
        }, [_createVNode(_component_el_input, {
          modelValue: $data.uploadSettings.ipQuery.customApi.responseFields[index],
          "onUpdate:modelValue": $event => $data.uploadSettings.ipQuery.customApi.responseFields[index] = $event,
          placeholder: _ctx.$t('sysSecurity.responseFieldPathPlaceholder')
        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]), _createVNode(_component_el_button, {
          plain: "",
          circle: "",
          onClick: $event => $options.moveIpQueryResponseField(index, -1),
          disabled: index === 0
        }, {
          default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
            icon: "arrow-up"
          })]),
          _: 1
        }, 8, ["onClick", "disabled"]), _createVNode(_component_el_button, {
          plain: "",
          circle: "",
          onClick: $event => $options.moveIpQueryResponseField(index, 1),
          disabled: index === $data.uploadSettings.ipQuery.customApi.responseFields.length - 1
        }, {
          default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
            icon: "arrow-down"
          })]),
          _: 1
        }, 8, ["onClick", "disabled"]), _createVNode(_component_el_button, {
          type: "danger",
          plain: "",
          circle: "",
          onClick: $event => $options.removeIpQueryResponseField(index)
        }, {
          default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
            icon: "trash-alt"
          })]),
          _: 1
        }, 8, ["onClick"])]);
      }), 128)), _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        onClick: $options.addIpQueryResponseField
      }, {
        default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
          icon: "plus"
        }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('sysSecurity.addResponseField')), 1)]),
        _: 1
      }, 8, ["onClick"])])]),
      _: 1
    })], 64)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["model"])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("h3", _hoisted_26, _toDisplayString(_ctx.$t('sysSecurity.accessManagement')), 1), _createElementVNode("h4", _hoisted_27, _toDisplayString(_ctx.$t('sysSecurity.domainFilter')), 1), _createVNode(_component_el_form, {
    model: $data.accessSettings,
    "label-width": "120px"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
      label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.allowedDomains')) + " ", 1), _createVNode(_component_el_tooltip, {
        content: _ctx.$t('sysSecurity.allowedDomainsTooltip'),
        placement: "top",
        "raw-content": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
          icon: "question-circle",
          style: {
            "margin-left": "5px",
            "cursor": "pointer"
          }
        })]),
        _: 1
      }, 8, ["content"])]),
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.accessSettings.allowedDomains,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $data.accessSettings.allowedDomains = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["model"]), _createElementVNode("h4", _hoisted_28, _toDisplayString(_ctx.$t('sysSecurity.whiteListMode')), 1), _createVNode(_component_el_form, {
    model: $data.accessSettings,
    rules: $options.accessRules,
    ref: "accessForm",
    "label-width": "120px"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
      label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.enableWhiteList')) + " ", 1), _createVNode(_component_el_tooltip, {
        content: _ctx.$t('sysSecurity.enableWhiteListTooltip'),
        placement: "top",
        "raw-content": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
          icon: "question-circle",
          style: {
            "margin-left": "5px",
            "cursor": "pointer"
          }
        })]),
        _: 1
      }, 8, ["content"])]),
      default: _withCtx(() => [_createVNode(_component_el_switch, {
        modelValue: $data.accessSettings.whiteListMode,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $data.accessSettings.whiteListMode = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["model", "rules"]), _createElementVNode("h4", _hoisted_29, _toDisplayString(_ctx.$t('sysSecurity.imageTransform')), 1), _createVNode(_component_el_form, {
    model: $data.accessSettings,
    rules: $options.accessRules,
    ref: "imageTransformForm",
    "label-width": "120px"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
      label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.enableImageTransform')) + " ", 1), _createVNode(_component_el_tooltip, {
        content: _ctx.$t('sysSecurity.enableImageTransformTooltip'),
        placement: "top",
        "raw-content": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
          icon: "question-circle",
          style: {
            "margin-left": "5px",
            "cursor": "pointer"
          }
        })]),
        _: 1
      }, 8, ["content"])]),
      default: _withCtx(() => [_createVNode(_component_el_switch, {
        modelValue: $data.accessSettings.imageTransformEnabled,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => $data.accessSettings.imageTransformEnabled = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }), $data.accessSettings.imageTransformEnabled ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 0,
      prop: "imageTransformAllowedSizes"
    }, {
      label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.imageTransformAllowedSizes')) + " ", 1), _createVNode(_component_el_tooltip, {
        content: _ctx.$t('sysSecurity.imageTransformAllowedSizesHint'),
        placement: "top",
        "raw-content": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
          icon: "question-circle",
          style: {
            "margin-left": "5px",
            "cursor": "pointer"
          }
        })]),
        _: 1
      }, 8, ["content"])]),
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.accessSettings.imageTransformAllowedSizes,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.accessSettings.imageTransformAllowedSizes = $event),
        placeholder: _ctx.$t('sysSecurity.imageTransformAllowedSizesPlaceholder')
      }, null, 8, ["modelValue", "placeholder"])]),
      _: 1
    })) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["model", "rules"]), _createElementVNode("h4", _hoisted_30, _toDisplayString(_ctx.$t('sysSecurity.sessionSecurityPolicy')), 1), _createVNode(_component_el_form, {
    model: $data.accessSettings,
    "label-width": "120px"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
      label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.secureMode')) + " ", 1), _createVNode(_component_el_tooltip, {
        content: _ctx.$t('sysSecurity.secureModeTooltip'),
        placement: "top"
      }, {
        default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
          icon: "question-circle",
          style: {
            "margin-left": "5px",
            "cursor": "pointer"
          }
        })]),
        _: 1
      }, 8, ["content"])]),
      default: _withCtx(() => [_createVNode(_component_el_switch, {
        modelValue: $data.accessSettings.sessionSecure,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => $data.accessSettings.sessionSecure = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: _ctx.$t('sysSecurity.userSessionMaxAge'),
      prop: "userSessionMaxAge"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input_number, {
        modelValue: $data.accessSettings.userSessionMaxAge,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $data.accessSettings.userSessionMaxAge = $event),
        min: 1,
        max: 3650,
        step: 1,
        precision: 0,
        "controls-position": "right"
      }, null, 8, ["modelValue"]), _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('sysSecurity.sessionMaxAgeUnit')), 1)]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: _ctx.$t('sysSecurity.adminSessionMaxAge'),
      prop: "adminSessionMaxAge"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input_number, {
        modelValue: $data.accessSettings.adminSessionMaxAge,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $data.accessSettings.adminSessionMaxAge = $event),
        min: 1,
        max: 3650,
        step: 1,
        precision: 0,
        "controls-position": "right"
      }, null, 8, ["modelValue"]), _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('sysSecurity.sessionMaxAgeUnit')), 1)]),
      _: 1
    }, 8, ["label"])]),
    _: 1
  }, 8, ["model"])]), _createVNode(_component_FloatingSaveButton, {
    show: !$data.loading,
    onClick: $options.saveSettings
  }, null, 8, ["show", "onClick"]), _createVNode(_component_el_dialog, {
    modelValue: $data.showCreateTokenDialog,
    "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => $data.showCreateTokenDialog = $event),
    title: _ctx.$t('sysSecurity.createTokenTitle'),
    width: $options.dialogWidth
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_34, [_createVNode(_component_el_button, {
      onClick: _cache[28] || (_cache[28] = $event => $data.showCreateTokenDialog = false)
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: $options.createToken
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.createBtn')), 1)]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.newToken,
      rules: $options.tokenRules,
      ref: "tokenForm",
      "label-width": "100px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: _ctx.$t('sysSecurity.tokenNameLabel'),
        prop: "name"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.newToken.name,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => $data.newToken.name = $event),
          placeholder: _ctx.$t('sysSecurity.tokenNamePlaceholder')
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysSecurity.permissionsLabel'),
        prop: "permissions"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
          modelValue: $data.newToken.permissions,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => $data.newToken.permissions = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_checkbox, {
            label: "upload"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.permUpload')), 1)]),
            _: 1
          }), _createVNode(_component_el_checkbox, {
            label: "delete"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.permDelete')), 1)]),
            _: 1
          }), _createVNode(_component_el_checkbox, {
            label: "list"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.permList')), 1)]),
            _: 1
          }), _createVNode(_component_el_checkbox, {
            label: "manage"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.permManage')), 1)]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysSecurity.neverExpire')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: $data.newToken.neverExpire,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => $data.newToken.neverExpire = $event),
          onChange: $options.onCreateNeverExpireChange
        }, null, 8, ["modelValue", "onChange"])]),
        _: 1
      }, 8, ["label"]), !$data.newToken.neverExpire ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 0,
        label: _ctx.$t('sysSecurity.validPeriod'),
        prop: "expirationValue"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_33, [_createVNode(_component_el_input_number, {
          modelValue: $data.newToken.expirationValue,
          "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => $data.newToken.expirationValue = $event),
          min: 1,
          step: 1,
          "controls-position": "right",
          style: {
            "flex": "1"
          }
        }, null, 8, ["modelValue"]), _createVNode(_component_el_select, {
          modelValue: $data.newToken.expirationUnit,
          "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => $data.newToken.expirationUnit = $event),
          style: {
            "width": "100px"
          }
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.timeUnitOptions, opt => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: opt.value,
              label: _ctx.$t(opt.labelKey),
              value: opt.value
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])])]),
        _: 1
      }, 8, ["label"])) : _createCommentVNode("", true), !$data.newToken.neverExpire ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 1,
        label: _ctx.$t('sysSecurity.autoDeleteOnExpire')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: $data.newToken.autoDelete,
          "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => $data.newToken.autoDelete = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"])) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }, 8, ["modelValue", "title", "width"]), _createVNode(_component_el_dialog, {
    modelValue: $data.showEditTokenDialog,
    "onUpdate:modelValue": _cache[37] || (_cache[37] = $event => $data.showEditTokenDialog = $event),
    title: _ctx.$t('sysSecurity.editTokenTitle'),
    width: $options.dialogWidth
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_36, [_createVNode(_component_el_button, {
      onClick: _cache[36] || (_cache[36] = $event => $data.showEditTokenDialog = false)
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: $options.updateToken
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.updateBtn')), 1)]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.editingToken,
      rules: $options.editTokenRules,
      ref: "editTokenForm",
      "label-width": "100px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: _ctx.$t('sysSecurity.tokenNameLabel')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.editingToken.name,
          "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => $data.editingToken.name = $event),
          disabled: ""
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysSecurity.permissionsLabel'),
        prop: "permissions"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
          modelValue: $data.editingToken.permissions,
          "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => $data.editingToken.permissions = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_checkbox, {
            label: "upload"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.permUpload')), 1)]),
            _: 1
          }), _createVNode(_component_el_checkbox, {
            label: "delete"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.permDelete')), 1)]),
            _: 1
          }), _createVNode(_component_el_checkbox, {
            label: "list"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.permList')), 1)]),
            _: 1
          }), _createVNode(_component_el_checkbox, {
            label: "manage"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.permManage')), 1)]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysSecurity.neverExpire')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: $data.editingToken.neverExpire,
          "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => $data.editingToken.neverExpire = $event),
          onChange: $options.onEditNeverExpireChange
        }, null, 8, ["modelValue", "onChange"])]),
        _: 1
      }, 8, ["label"]), !$data.editingToken.neverExpire ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 0,
        label: _ctx.$t('sysSecurity.validPeriod'),
        prop: "expirationValue"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_35, [_createVNode(_component_el_input_number, {
          modelValue: $data.editingToken.expirationValue,
          "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => $data.editingToken.expirationValue = $event),
          min: 1,
          step: 1,
          "controls-position": "right",
          style: {
            "flex": "1"
          }
        }, null, 8, ["modelValue"]), _createVNode(_component_el_select, {
          modelValue: $data.editingToken.expirationUnit,
          "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => $data.editingToken.expirationUnit = $event),
          style: {
            "width": "100px"
          }
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.timeUnitOptions, opt => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: opt.value,
              label: _ctx.$t(opt.labelKey),
              value: opt.value
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])])]),
        _: 1
      }, 8, ["label"])) : _createCommentVNode("", true), !$data.editingToken.neverExpire ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 1,
        label: _ctx.$t('sysSecurity.autoDeleteOnExpire')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: $data.editingToken.autoDelete,
          "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => $data.editingToken.autoDelete = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"])) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }, 8, ["modelValue", "title", "width"]), _createVNode(_component_el_dialog, {
    modelValue: $data.showTokenResultDialog,
    "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => $data.showTokenResultDialog = $event),
    title: _ctx.$t('sysSecurity.tokenCreatedTitle'),
    width: $options.dialogWidth
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_39, [_createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[39] || (_cache[39] = $event => $data.showTokenResultDialog = false)
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.savedBtn')), 1)]),
      _: 1
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_37, [_createElementVNode("p", _hoisted_38, [_createVNode(_component_font_awesome_icon, {
      icon: "exclamation-triangle",
      style: {
        "margin-right": "5px"
      }
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('sysSecurity.tokenCreatedWarning')), 1)]), _createVNode(_component_el_form, {
      "label-width": "100px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: _ctx.$t('sysSecurity.tokenNameLabel')
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($data.createdToken.name), 1)]),
        _: 1
      }, 8, ["label"]), _createVNode(_component_el_form_item, {
        label: _ctx.$t('sysSecurity.fullToken')
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.createdToken.token,
          "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => $data.createdToken.token = $event),
          readonly: ""
        }, {
          append: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: $options.copyToken
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysSecurity.copyBtn')), 1)]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"])]),
      _: 1
    })])]),
    _: 1
  }, 8, ["modelValue", "title", "width"])])), [[_directive_loading, $data.loading]]);
}